import React, { useState } from "react";
import { MessageCircleQuestion, X } from "lucide-react";
import { useLocation } from "react-router-dom";
import SupportChat from "./SupportChat";
import EscalationForm from "./EscalationForm";

export const SupportWidget = () => {
  const [open, setOpen] = useState(false);
  const [escalating, setEscalating] = useState(null);
  const { pathname } = useLocation();

  if (pathname.startsWith("/staff") || pathname.startsWith("/support")) return null;

  return (
    <>
      <button
        onClick={() => setOpen((value) => !value)}
        aria-label={open ? "Close technical support" : "Open EI Technical Support"}
        aria-expanded={open}
        data-testid="support-widget-toggle"
        className="fixed bottom-5 right-5 z-[60] inline-flex items-center gap-2 bg-ei-navy text-ei-white font-display text-xs font-bold px-4 py-3.5 rounded-full shadow-lg shadow-ei-navy/25 border border-ei-gold/40 hover:bg-ei-navy/90 focus:outline-none focus-visible:ring-2 focus-visible:ring-ei-gold focus-visible:ring-offset-2 transition-colors min-h-[48px]"
      >
        {open ? <X className="w-4 h-4" /> : <MessageCircleQuestion className="w-4 h-4 text-ei-gold" />}
        <span className="hidden sm:inline">{open ? "Close" : "Technical support"}</span>
      </button>

      {open && (
        <div
          role="dialog"
          aria-label="EI Technical Support assistant"
          data-testid="support-widget-panel"
          className="fixed z-[59] bg-white border border-ei-mist shadow-2xl shadow-ei-navy/20 flex flex-col
                     inset-x-0 bottom-0 top-16 rounded-t-lg
                     sm:inset-auto sm:bottom-24 sm:right-5 sm:top-auto sm:w-[420px] sm:h-[70vh] sm:rounded-md"
        >
          <div className="flex items-center justify-between px-4 py-3 bg-ei-navy text-ei-white rounded-t-lg sm:rounded-t-md">
            <div>
              <div className="font-display text-sm font-bold">EI Technical Support</div>
              <div className="text-[11px] text-ei-white/60">AI assistant · answers cited from approved documents</div>
            </div>
            <button onClick={() => setOpen(false)} aria-label="Close technical support" data-testid="support-widget-close" className="p-2 hover:bg-ei-white/10 rounded-sm">
              <X className="w-4 h-4" />
            </button>
          </div>
          <div className="flex-1 min-h-0 overflow-y-auto">
            {escalating ? (
              <div className="p-3">
                <EscalationForm product={escalating.product} sessionId={escalating.sessionId} onDone={() => setEscalating(null)} />
              </div>
            ) : (
              <SupportChat compact onRequestEscalation={(product) => setEscalating({ product, sessionId: null })} />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default SupportWidget;
